import React from 'react';
import Router from './Router';
import { ToastProvider } from './hooks';
import './styles/animations.css';

function App() {
  return (
    <div className="grain-overlay">
      <ToastProvider>
        <Router />
      </ToastProvider>
    </div>
  );
}

export default App;
